import style from './block.module.scss';
import logo from './logo.svg';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Newsletter from './newsletter';
import Social from './social';

function Block({ siteName, mainMenu, secondaryMenu, customSettings}) {
    return (
        <div className={style.block}>
            <div className={style.container}>
                <div className={style.grid}>
                    <div className={style.left}>
                        <a href="/" className={style.logo}>
                            <img src={logo} alt={siteName} />
                        </a>
                        <div className={style.address}>
                            {customSettings.streetAddress && <p>{customSettings.streetAddress}</p>}
                            {customSettings.postalCode && customSettings.city && <p>
                                {customSettings.postalCode} {customSettings.city}
                            </p>}
                            {customSettings.telephone && <p><a href={`tel: ${customSettings.telephone}`}>{customSettings.telephone}</a></p> }
                            {customSettings.email && <p><a href={`mailto: ${customSettings.email}`}>{customSettings.email}</a></p> }
                        </div>
                    </div>
                    <div className={style.middle}>
                        <div className={style.middleGrid}>
                            <ul className={style.menu}>
                                {Object.keys(mainMenu).map((id) => (
                                    <li key={`main-menu-${id}`}><a href={mainMenu[id].url}>{mainMenu[id].title} <span><ArrowForwardIosIcon /></span></a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className={style.right}>
                        <Newsletter successMsg={customSettings.successMsg || 'Votre inscription a la newsletter a bien été prise en compte.' } />
                        <Social customSettings={customSettings} />
                    </div>
                </div>
                <div className={style.bottom}>
                    <ul className={style.bottomMenu}>
                        { Object.keys(secondaryMenu).map((id) => (
                            <li key={`secondmenu-${id}`}><a href={secondaryMenu[id].url}>{secondaryMenu[id].title}</a></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Block;